import { ReactElement } from "react";
import { useInAppAssistant } from "@timeedit/shared-ai-sdk/in-app-assistant/react";
import { AgentPopover } from "@timeedit/ui-components/components/SupportAgent/AgentPopover";
import { getAccessToken } from "@timeedit/ui-components/components/AuthWrapper/AuthWrapper";
import { EAppId } from "@timeedit/types/lib/enums/appIds.enum";
import { useAppContext } from "../../contexts/AppContext";
import { getSharedAiUrl } from "../../lib/ServiceUrls";
import { TComponent } from "../../types/utils";

type TTopbarSupportAgentProps = {
    open: boolean;
    onClose: () => void;
    /** The element the popover is anchored to */
    children: ReactElement;
};

const TopbarSupportAgent: TComponent<TTopbarSupportAgentProps> = ({ open, onClose, children }) => {
    const { env } = useAppContext();
    const assistant = useInAppAssistant({
        products: [EAppId.TE_CORE],
        getToken: getAccessToken,
        baseUrl: getSharedAiUrl(env?.serverEnv, env?.serverRegion),
        onError: (error) => console.error("Support agent request failed", error),
    });

    // Only the help menu opens the popover, so ignore open requests from clicking the anchor
    return (
        <AgentPopover
            {...assistant}
            speech
            open={open}
            onOpenChange={(nextOpen) => !nextOpen && onClose()}
            trigger={<span>{children}</span>}
        />
    );
};

export default TopbarSupportAgent;
